// export const cleanInput = (data) => {
//     for (const key in data) {
//         if (Object.hasOwnProperty.call(data, key)){
//             if (data[key] === null || data[key] === '') {
//                 delete data[key];
//             }
//         }
//     }

//     return true;
// }

export const cleanInput = (data) => {
  for (const key in data) {
    if (!Object.hasOwnProperty.call(data, key)) continue;

    const value = data[key];

    const isEmpty =
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === "object" &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0);

    if (isEmpty) {
      delete data[key];
    }
  }

  return true;
};